import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SpinnerComponent } from "./spinner/spinner.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { SpinnerRequestResponseInterceptor } from "./interceptor/spinner-request-response.interceptor";
import { NgxSpinnerModule } from "ngx-spinner";
@NgModule({
  declarations: [SpinnerComponent],
  imports: [CommonModule, NgxSpinnerModule],
  exports: [SpinnerComponent, NgxSpinnerModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerRequestResponseInterceptor,
      multi: true,
    },
  ],
})
export class SpinnerModule {}
